import React from 'react'
import { Table } from '../components/ui/Table'
import { time } from '../util/formatters'
import { useSelector } from 'react-redux'
import { axiosGet } from '../util/api'
import { differenceInMinutes, parseISO } from 'date-fns'
import { UpdateStatusBadge } from '../components/badge/UpdateStatusBadge'
import { UpdateSnapshotAdType } from '../components/badge/UpdateSnapshotAdTypeBadge'
import { Filters } from '../config'
import { Layout } from '../components/Layout'

export const SnapshotUpdates = (_) => {
    const profile = useSelector((state) => state.user.profile)
    const load = (params) => {
        if (!profile) {
            return Promise.resolve()
        }

        return axiosGet('snapshot-updates', params)
    }

    const columns = [
        { key: 'status', cell: UpdateStatusBadge },
        { key: 'location' },
        { key: 'snapshot_id' },
        { key: 'type', cell: UpdateSnapshotAdType },
        { key: 'created_at', title: 'Started', formatter: time },
        { key: 'updated_at', title: 'Finished', formatter: time },
        {
            title: 'Run Time',
            cell: (v) => {
                const start = parseISO(v.created_at)
                const end = parseISO(v.updated_at)
                const diff = differenceInMinutes(end, start)

                if (!diff) {
                    return '-'
                }

                return `${diff} mins`
            },
        },
    ]

    const filters = [Filters.UpdateStatus, Filters.UpdateReportType]

    return (
        <Layout primary="Snapshot Updates">
            <Table
                name={'Snapshot Updates'}
                showHeader={false}
                load={load}
                dateSelect
                filters={filters}
                columns={columns}
            />
        </Layout>
    )
}
